module.exports = __webpack_public_path__ + "img/svg4.8aed9d1c.svg";